import { render, staticRenderFns } from "./ProdutosGrid.vue?vue&type=template&id=7e9ee85e&scoped=true"
import script from "./ProdutosGrid.vue?vue&type=script&lang=js"
export * from "./ProdutosGrid.vue?vue&type=script&lang=js"
import style0 from "./ProdutosGrid.vue?vue&type=style&index=0&id=7e9ee85e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9ee85e",
  null
  
)

export default component.exports